export default __webpack_public_path__ + "static/colored-cir-novo-ff64128a85831cb99b669f5da0f01215.png";